import { get } from 'vuex-pathify'

export default {
  computed: {
    selectedQuery: get('query-details/selectedQuery', false)
  }
}
